const searchSupplierSortingFields = {
  none: -1,
  relevance: 0,
  registeredName: 1,
  dateModified: 2,
  supplierRating: 3,
};

export default searchSupplierSortingFields;
